<template>
  <el-row class="xh-esg-page">
    <el-col :span="24" v-if="pageInfo">
      <div class="xh-esg-right-content">
        <el-row class="xh-esg-page-container" :gutter="20">
          <el-col :span="24" class="xh-esg-page-header">
            <el-row>
              <el-col :span="10">
                <div class="xh-esg-page-title">{{ pageInfo.short_name }}</div>
                <div class="xh-esg-page-code">（{{ pageInfo.ticker }}）</div>
              </el-col>
              <el-col :span="14">
                <div class="xh-esg-page-norm-container">
                  <div class="xh-esg-page-norm xh-esg-page-norm-split">
                    <div class="xh-esg-page-norm-num-container">
                      <div class="xh-esg-page-norm-num">
                        {{ pageInfo.ESG_score }}
                      </div>
                      <!-- 2021-12-01 TODO 半年后才有对比数据 -->
                      <!-- <i class="xh-esg-page-norm-icon el-icon-top"></i> -->
                    </div>
                    <div class="xh-esg-page-norm-sub-container">
                      <div class="xh-esg-page-norm-sub">总评分</div>
                      <div class="xh-esg-page-norm-time">
                        {{ pageInfo.data_date }}
                      </div>
                    </div>
                  </div>
                  <div class="xh-esg-page-norm">
                    <div class="xh-esg-page-norm-num">
                      {{ pageInfo.E_score }}
                    </div>
                    <div class="xh-esg-page-norm-sub">环境评分</div>
                  </div>
                  <div class="xh-esg-page-norm">
                    <div class="xh-esg-page-norm-num blue">
                      {{ pageInfo.S_score }}
                    </div>
                    <div class="xh-esg-page-norm-sub">社会评分</div>
                  </div>
                  <div class="xh-esg-page-norm">
                    <div class="xh-esg-page-norm-num red">
                      {{ pageInfo.G_score }}
                    </div>
                    <div class="xh-esg-page-norm-sub">治理评分</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <div class="xh-esg-page-info">
              <el-row>
                <el-col :span="6">
                  <div class="xh-esg-page-info-title">基金类型：</div>
                  <div class="xh-esg-page-info-content">
                    {{ pageInfo.investment_type }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="xh-esg-page-info-title">基金经理：</div>
                  <div class="xh-esg-page-info-content">
                    {{ pageInfo.manager }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="xh-esg-page-info-title">成立日期：</div>
                  <div class="xh-esg-page-info-content">
                    {{ pageInfo.product_start_date }}
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="xh-esg-page-info-title">发行机构：</div>
                  <div class="xh-esg-page-info-content">
                    {{ pageInfo.Issuer }}
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="xh-esg-page-info-title">最新净值：</div>
                  <div :class="pageInfo.NVDailyGrowthRate_r < 0?'xh-esg-page-info-content green':'xh-esg-page-info-content red'" v-show="pageInfo.UnitNV_r">
                    {{ pageInfo.UnitNV_r }}({{ pageInfo.NVDailyGrowthRate_r? ((pageInfo.NVDailyGrowthRate_r * 100).toFixed(2) + "%"): ""}})
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="xh-esg-page-info-title">累计净值：</div>
                  <div class="xh-esg-page-info-content">
                    {{ pageInfo.AccumulatedUnitNV_r }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="xh-esg-page-info-title">净资产规模：</div>
                  <div
                    class="xh-esg-page-info-content"
                    v-show="pageInfo.asset_size"
                  >
                    {{
                      Number((pageInfo.asset_size || 0) / 100000000).toFixed(2)
                    }}亿元
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      pageInfo: null,
    };
  },
  components: {},
  mounted() {
    let { query } = this.$route;
    this.getPageInfo(query).then((data) => {
      data = data.data;
      if (data && data.length) {
        this.pageInfo = data[0];
      }
    });
  },
  methods: {
    ...mapActions("investInfo/page", {
      getPageInfo: "GET_FUNDS_INFO",
    }),
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-page {
  .xh-esg-right-content {
    background-color: #ffffff;
    padding: 30px 50px;
    // min-height: 520px;
    .xh-esg-page-container {
      .xh-esg-page-header {
        margin-bottom: 20px;
        .xh-esg-page-title {
          font-size: 24px;
          font-weight: 500;
          color: var(--font_01);
          line-height: 33px;
        }
        .xh-esg-page-code {
          margin-top: 5px;
          font-size: 16px;
          font-weight: 400;
          color: var(--font_01);
          line-height: 22px;
        }
        .xh-esg-page-norm-container {
          .xh-esg-page-norm {
            display: inline-block;
            vertical-align: middle;
            padding-left: 30px;
            text-align: center;
            &.xh-esg-page-norm-split {
              border-right: 1px solid var(--xhcj-font-split);
              padding-left: 0;
              padding-right: 35px;
            }
            .xh-esg-page-norm-num {
              font-size: 36px;
              font-weight: normal;
              color: #90cc75;
              line-height: 60px;
              height: 60px;
              &.blue {
                color: #5470c6;
              }
              &.red {
                color: #f47373;
              }
            }
            .xh-esg-page-norm-sub {
              margin-top: 5px;
              font-size: 10px;
              font-weight: 400;
              color: var(--xhcj-sub-font_01);
              line-height: 14px;
            }
            .xh-esg-page-norm-num-container {
              height: 60px;
              .xh-esg-page-norm-num {
                font-size: 48px;
                font-weight: 700;
                letter-spacing: -4px;
                color: var(--font_01);
                line-height: 60px;
                display: inline-block;
                vertical-align: middle;
              }
              .xh-esg-page-norm-icon {
                display: inline-block;
                vertical-align: middle;
                color: #fc4b4e;
                font-size: 30px;
                font-weight: bold;
                line-height: 60px;
              }
            }
            .xh-esg-page-norm-sub-container {
              .xh-esg-page-norm-sub {
                display: inline-block;
                vertical-align: middle;
              }
              .xh-esg-page-norm-time {
                margin-top: 5px;
                margin-left: 5px;
                display: inline-block;
                vertical-align: middle;
                font-weight: 400;
                color: #a1a7af;
                line-height: 14px;
                font-size: 10px;
              }
            }
          }
        }
      }

      .xh-esg-page-info {
        padding: 20px;
        background: var(--comp_06);

        .xh-esg-page-info-title {
          display: inline-block;
          vertical-align: middle;
          margin-top: 10px;
          font-weight: 400;
          color: var(--font_01);
          line-height: 17px;
        }
        .xh-esg-page-info-content {
          margin-left: 5px;
          margin-top: 10px;
          display: inline-block;
          vertical-align: middle;
          font-weight: 400;
          color: var(--font_01);
          line-height: 17px;
          &.red {
            color: #fc4b4e;
          }
          &.green {
            color: #2fb856;
          }
        }
      }
    }
  }
}
</style>